module.exports = __webpack_public_path__ + "img/overcoat.e63d51bf.png";